module.exports = __webpack_public_path__ + "static/media/banner2.6c5c3d4e.jpg";